import axios from 'axios';
import Space from 'antd/lib/space';
import { Col, Row } from 'antd/lib/grid';
import Form from 'antd/lib/form';
import { unflatten } from 'flat';
import Button from 'antd/lib/button';
import message from 'antd/lib/message';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CountrySelector from '../../../components/CountrySelector';
import { useSettingsContext } from '../../../context/SettingsContext';
import StepPageLayout from '../StepPageLayout';
import LanguageSwitcher from '../../../components/LanguageSwitcher';
import LanguageSwitcherPreview from '../../../components/LanguageSwitcher/LanguageSwitcherPreview';

function Step1() {
  const navigate = useNavigate();
  const { handleSettingsData } = useSettingsContext();
  const [nextBtnLoading, setNextBtnLoading] = useState(false);
  const [backBtnLoading, setBackBtnLoading] = useState(false);

  const handleFinish = (form) => {
    setNextBtnLoading(true);
    const data = { ...unflatten(form.getFieldsValue(true)), stepReached: 5 };
    axios
      .put('/settings', data)
      .then((res) => {
        handleSettingsData(res.data);
        setNextBtnLoading(false);
        navigate('/step-5');
      })
      .catch(() => {
        message.error('Something went wrong');
        setNextBtnLoading(false);
      });
  };

  const handleBack = () => {
    setBackBtnLoading(true);
    const data = { stepReached: 3 };
    axios
      .put('/settings', data)
      .then((res) => {
        handleSettingsData(res.data);
        setBackBtnLoading(false);
        navigate('/step-3');
      })
      .catch(() => {
        message.error('Something went wrong');
        setBackBtnLoading(false);
      });
  };

  return (
    <StepPageLayout
      handleFinish={handleFinish}
      spinning={nextBtnLoading || backBtnLoading}
      title='Step 4: Language Switcher'
      subTitle='Let your international customers browse your store in their language'
    >
      <Row className='stepContainer'>
        <Col xs={24} md={16} className='leftSection'>
          <LanguageSwitcher />
        </Col>
        <Col xs={24} md={8} className='rightSection'>
          <Space direction='vertical' style={{ width: '100%' }}>
            <div className='previewText'>Preview</div>
            <Form.Item dependencies={['desktop.showLanguageSwitcher']}>
              {/* If showLanguageSwitcher is false then show only country selector */}
              {({ getFieldValue }) =>
                getFieldValue(`desktop.showLanguageSwitcher`) ? (
                  <LanguageSwitcherPreview device='desktop' />
                ) : (
                  <CountrySelector device='desktop' />
                )
              }
            </Form.Item>
          </Space>
        </Col>
        <Col xs={24} md={16}>
          <div className='save-btn-wrapper'>
            <Space align='center' size={24}>
              <Button
                style={{ width: 85 }}
                loading={backBtnLoading}
                onClick={handleBack}
              >
                Back
              </Button>
              <Button
                type='primary'
                htmlType='submit'
                style={{ width: 170 }}
                loading={nextBtnLoading}
              >
                Next
                <i className='las la-arrow-right' />
              </Button>
            </Space>
          </div>
        </Col>
      </Row>
    </StepPageLayout>
  );
}

export default Step1;
